jQuery(document).ready(function ($) {
  $('.menu-button').click(function () {
    $(this).toggleClass('active');
    $('#top-menu-nav').toggleClass('active');
    return false;
  });

  $(window).resize(function () {
    // This will fire each time the window is resized:
    if ($(window).width() >= 768) {
      $('#top-menu .sub-menu').show();
    } else {
      $('#top-menu').on('click', 'li.menu-item-has-children', function (event) {
        event.preventDefault();
        $(this).removeClass('menu-item-has-children');
        $(this).addClass('current-toggle-menu');
        $(this).children('.sub-menu').addClass('activesubmenu');
      });
      $('#top-menu').on('click', 'li.current-toggle-menu a[href^="#"]', function (event) {
        event.preventDefault();
        $(this).parent().removeClass('current-toggle-menu');
        $(this).parent().addClass('menu-item-has-children');
        $(this).parent().children('.sub-menu').removeClass('activesubmenu');
      });
      $('#top-menu').on('click', 'li.current-toggle-menu .arrow-bottom', function (event) {
        event.preventDefault();
        $(this).parent().removeClass('current-toggle-menu');
        $(this).parent().addClass('menu-item-has-children');
        $(this).parent().children('.sub-menu').removeClass('activesubmenu');
      });
    }
  }).resize(); // This will simulate a resize to trigger the initial run.
});
